<template>
  <div
    class="d-flex justify-center align-center text-center"
    style="height: 100%"
  >
    <div>
      <img
        src="@/assets/images/404-image.svg"
        :width="$vuetify.display.smAndDown ? '' : '503'"
        alt="404"
      />
      <h1 class="text-size-24 poppins-700 pt-2 text-white">Opps!!!</h1>
      <h4 class="ma-6 text-white">
        This page you are looking for could not be found.
      </h4>
      <v-btn
        min-height="50px"
        color="white"
        variant="flat"
        class="text-capitalize mb-7 px-7 py-3"
        to="/"
      >
        <span class="text-primaryLighter"> Go Back to Home </span>
      </v-btn>
    </div>
  </div>
</template>
